import React from 'react';
import './ActiveFilters.scss';

import FilterDtm from './FilterDtm';
import { readQueryParam } from '../../../utils/helper';

const handleDelete = (FilterDataObj, filtername, childid, props) => {
  const { categoryActions, location, categoryId, filterDrop, handleFilterFunction } = props;

  if (filterDrop === filtername) {
    categoryActions.filterDropdown(false);
  }

  FilterDataObj[filtername].splice(childid, 1);

  if (FilterDataObj[filtername].length === 0) {
    FilterDtm.updateFilterDtm(filtername);
  }

  /* To remove Items from URL. */
  if (FilterDataObj[filtername].length === 0 && Object.keys(FilterDataObj).length === 1) {
    /* To remove last item from stored object and location. */
    delete FilterDataObj[filtername];

    const locationHash = location.hash;
    let loc = '';

    if (locationHash.includes('dir')) {
      loc = locationHash.slice(
        locationHash.lastIndexOf('dir'),
        locationHash.lastIndexOf('true') + 4
      );
    }

    history.pushState('', '', `#${loc}`);

    const temp = {};

    temp.location = location;
    temp.location.hash = `${loc}`;
    temp.counter = 1;
    temp.FilterDataObj = {};
    temp.reset = true;

    categoryActions.modifyData(temp);

    let searchQuery = '';
    if (location.pathname === '/search' && readQueryParam('q', `${location.search}`, true)) {
      searchQuery = `?q=${readQueryParam('q', `${location.search}`, true)}`;
    }

    history.replaceState(
      `${location.pathname}${location.hash}`,
      null,
      location.pathname + `${searchQuery}#${location.hash}`
    );

    categoryActions.loadCatAndFilterData(categoryId, `${loc}`, 0);
  } else {
    const apiData = {};

    Object.keys(FilterDataObj).forEach(data => {
      apiData[`filter_${data}`] = FilterDataObj[data];
    });

    handleFilterFunction(filtername, FilterDataObj[filtername], FilterDataObj, apiData);

    /* To add items in props. */
    categoryActions.addFilterData(FilterDataObj);
  }
};

const ActiveFilter = props => {
  const { FilterDataObj, filterData, location, modifySelectedFilterList } = props;

  const cleanedFilterDataObj = Object.entries(FilterDataObj).reduce(
    (acc, [filterName, selectedOptions]) => {
      if (selectedOptions.length) {
        acc[filterName] = selectedOptions;
      } else {
        delete FilterDataObj[filterName];
      }

      return acc;
    },
    {}
  );

  const filterDataAll = filterData && filterData.result && filterData.result.filters;

  const searchTextParam = readQueryParam('q', location.search, true);

  const handleClearSearchText = () => {
    if (filterDataAll && Object.keys(cleanedFilterDataObj)?.length) {
      window.location.href = '/eyeglasses/frame-shape/round.html';
    } else {
      window.history.back();
    }
  };

  if (!filterDataAll || (!Object.keys(cleanedFilterDataObj).length && !searchTextParam)) {
    return <div />;
  }

  return (
    <div className="active-filters">
      <div className="active-filters__list">
        {searchTextParam && (
          <div className="active-filters__filter od-font-reg">
            <span>{searchTextParam}</span>
            <i
              className="fa fa-close active-filters__remove-icon"
              onClick={handleClearSearchText}
            />
          </div>
        )}
        {filterDataAll && Object.keys(cleanedFilterDataObj).length
          ? Object.entries(cleanedFilterDataObj).map(([filterName, selectedOptions]) =>
              selectedOptions.map(({ childid, childname }, key) => {
                return (
                  <div key={childid} className="active-filters__filter od-font-reg">
                    <span>{childname}</span>
                    <i
                      className="fa fa-close active-filters__remove-icon"
                      // onClick={() => handleDelete(cleanedFilterDataObj, filterName, key, props)}
                      onClick={() =>
                        modifySelectedFilterList(childname, childid, { id: filterName })
                      }
                    />
                  </div>
                );
              })
            )
          : null}
      </div>
    </div>
  );
};

export default ActiveFilter;
